const accordions = document.querySelectorAll('.accordion');

accordions.forEach(accordion => {
  const accordionToggle = accordion.querySelector('.accordion-toggle');       
  const accordionContent = accordion.querySelector('.accordion-content');
  const isExpanded = accordionContent.getAttribute('data-expanded') === 'true';

  accordionToggle.addEventListener('click', () => {
    accordionContent.setAttribute('data-expanded', !isExpanded);
    accordion.classList.toggle('accordion--expanded');
  });
});